import React, { useContext } from 'react';
import './ChristmasLights.css';


const ChristmasLights = () => {

  const lightCount = 30;
  const colors = ['#ff0000', '#00ff00', '#ffff00', '#ff00ff', '#00ffff', '#ff8800'];

  return (
    <div className="christmas-lights-container">
      <div className="lights-string">
        {Array.from({ length: lightCount }).map((_, i) => {
          const color = colors[i % colors.length];
          const delay = Math.random() * 4;
          const duration = 1 + Math.random() * 2;

          return (
            <div
              key={i}
              className="light-bulb"
              style={{
                '--light-color': color,
                '--blink-delay': `${delay}s`,
                '--blink-duration': `${duration}s`,
              }}
            >
              <div className="bulb-glow"></div>
              <div className="bulb-reflection"></div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ChristmasLights;